export const [START_LOADING, STOP_LOADING,SELECT_CONTROLLER,SELECT_POINT_OF_SALES,SELECT_USERS] = ["START_LOADING", "STOP_LOADING","SELECT_CONTROLLER","SELECT_POINT_OF_SALES","SELECT_USERS"];
